import { useEffect, useState } from "react"

const defaultViewport = {
    latitude: 23.866980789984908,
    longitude: -102.48693758189374,
    zoom: 4
}

export default function usePositionedViewport() {
    const [viewport, setViewport] = useState(null)

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition((pos) => {
                setViewport({
                    latitude: pos.coords.latitude,
                    longitude: pos.coords.longitude,
                    zoom: 8,
                });
            }, () => {
                setViewport(defaultViewport);
            });
        } else {
            setViewport(defaultViewport);
        }
    }, []);

    return viewport
}
